module.exports = __webpack_public_path__ + "img/02eebff636d60ec2ada42b3620e81cd6.jpg";